module.exports = __webpack_public_path__ + "assets/img/xiuli-4ae8676a.png";